import React from 'react';

import {
  ROLE_ADMIN_USER,
  ROLE_CUSTOM_OFFER_ADMIN_USER,
  ROLE_EMPLOYEE_USER,
  ROLE_HOTEL_COORDINATOR,
  ROLE_ICS_STORE_TEAM,
  ROLE_ROLE_ADMIN,
} from '~/consts/roles';

import ErrorDisplay from '../components/Common/ErrorDisplay';

const adminPermissionError = {
  name: 'PermissionError',
  message: "You don't have the permissions for this operation",
};

/**
 *
 * @param {*} user the user to check if is admin
 * @returns {boolean} if the user is admin or not
 *
 * @example
 * isAdmin({
 *   roles: ['admin']
 * }
 */
export function isAdmin(user) {
  return user?.roles?.includes(ROLE_ADMIN_USER);
}

export function isAdminOrEmployee(user) {
  return user?.roles?.includes(ROLE_ADMIN_USER) || user?.roles?.includes(ROLE_EMPLOYEE_USER);
}

export function canViewVccDetails(user) {
  if (!user?.roles) {
    return false;
  }
  return (
    isAdminOrEmployee(user) || !user.roles.some((role) => [ROLE_HOTEL_COORDINATOR, ROLE_ICS_STORE_TEAM].includes(role))
  );
}

export function errorMonitor(user) {
  if (!user?.roles?.includes(ROLE_ADMIN_USER)) {
    throw adminPermissionError;
  }
}

export function errorDisplay(user) {
  if (!user?.roles) {
    return null;
  }
  if (!user.roles.includes(ROLE_ADMIN_USER)) {
    return <ErrorDisplay message={adminPermissionError.message} />;
  }
}

export function isCustomOfferAdmin(user) {
  return isAdmin(user) || user?.roles?.includes(ROLE_CUSTOM_OFFER_ADMIN_USER);
}

// Mirrors the svc-auth v2 admin account enable/disable pre-handlers,
// which require both roles (requireAdminUser + requireRoleAdmin).
export function canEnableDisableAccounts(user: { roles?: Array<string> } | null | undefined) {
  return Boolean(user?.roles?.includes(ROLE_ADMIN_USER) && user.roles.includes(ROLE_ROLE_ADMIN));
}
